import DataSetResponseCreateContainer from './data_set_response_create_container';

const DataSetResponseCreate = DataSetResponseCreateContainer;

export default DataSetResponseCreate;
